import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ChatSmallIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    fill: "currentColor",
    width: size || '9',
    height: size || '9'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 6v2.594a.3.3 0 0 1-.488.233L6.242 7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5z",
    fillRule: "evenodd"
  }));
};
ChatSmallIcon.displayName = 'ChatSmallIcon';
export default ChatSmallIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatSmallIcon.js.map